<template>
	<div class="common-shell">
		<gc-header :header-data="headerData">
			<template #ops>
				<el-button v-click-blur style="width: 100px" type="primary" @click="exportTable">导出报表</el-button>
			</template>
		</gc-header>
		<div class="common-shell-content">
			<div class="left-filter">
				<el-form ref="reportForm" :model="params" :rules="rednderConfig.formRules">
					<div class="filter-modules" v-for="item in rednderConfig.filterArr" :key="item.title">
						<div class="title">{{ item.title }}</div>
						<div class="item" v-for="filter in handleFilters(item.filterList)" :key="filter.key">
							<el-form-item :prop="filter.key">
								<gc-custom-search
									:type="filter.type || ''"
									:key-word="filter.keyWord"
									:required="filter.required"
									:width="filter.width || '330px'"
									:key-word-width="filter.keyWordWidth"
									:search.sync="params[filter.key]"
									:need-all-for-search="filter.needAll === false ? false : true"
									:search-option="filter.options || searchOption[filter.dicKey || filter.key] || []"
									:filterable="filter.filterable || false"
									:remote="filter.remote || false"
									:remote-method="
										filter.remoteMethod ? remoteMethodMap[filter.remoteMethod] : undefined
									"
									:select-loading="selectLoading[filter.dicKey || filter.key] || false"
									:date-picker-type="filter.datePickerType"
									:class-date-time="filter.datePickerType === 'datetimerange'"
									:format="filter.format"
									:value-format="filter.valueFormat"
									:select-clearable="filter.clearable || false"
									:clearable="filter.clearable"
									:showSearch="filter.showSearch"
									:propsObj="filter.propsObj"
									:multiple="filter.multiple"
									treeSelectClearable
								>
									<template v-if="filter.icon || filter.unit" v-slot:icon>
										<i v-if="filter.icon" :class="['iconfont', `${filter.icon}`]"></i>
										<span v-if="filter.unit">{{ filter.unit }}</span>
									</template>
								</gc-custom-search>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="button-zone">
					<el-button v-click-blur type="primary" @click="query">查 询</el-button>
					<el-button v-click-blur @click="reset">重 置</el-button>
				</div>
			</div>
			<div class="right-table">
				<div class="table" v-loading="loading">
					<div
						class="water-statistic"
						v-if="totalStatistic && tenantType == 1 && ['deviceDevelop', 'alarmDeal'].includes(type)"
					>
						<div class="t">合计</div>
						<div class="statistic-item" v-for="item in columns.filter(o => o.hasTotal)" :key="item.key">
							<p>{{ item.name }}</p>
							<span>{{ totalStatistic[item.key] }}</span>
						</div>
					</div>
					<div class="table-content">
						<gc-table
							ref="table"
							border
							showPage
							:total="total"
							:columns="columns"
							:table-data="tableData"
							:current-page.sync="currentPage"
							:page-size="pageSize"
							@size-change="handleSizeChange"
							@current-page-change="pageChange"
						></gc-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const exportMaps = {
	deviceDevelop: {
		url: '/monitor/report/device-develop/export/excel',
		fileName: '设备发展量统计.xls',
	},
	alarmDeal: {
		url: '/monitor/report/alarm-process/export/excel',
		fileName: '告警处理情况统计.xls',
	},
	factoryAlarm: {
		url: '/monitor/report/device-alarm/export/excel',
		fileName: '厂商告警设备对比.xls',
	},
	smsPush: {
		url: '/monitor/report/alarm/sms-push/export/excel',
		fileName: '短信推送报表.xls',
	},
	meterRate: {
		url: '/monitor/report/meter-reading/export/excel',
		fileName: '抄表率统计.xls',
	},
	manyDaysNoUpload: {
		url: '/monitor/report/exception/no-upload/export/excel',
		fileName: '多天不上传统计.xls',
	},
	valveOperate: {
		url: '/monitor/report/exception/valve-opt/export/excel',
		fileName: '阀门操作统计.xls',
	},
}

const useWaterRecordExportMaps = {
	0: {
		url: '/monitor/report/water-used-detail/export/excel',
		fileName: '用水记录明细.xls',
	},
	1: {
		url: '/monitor/report/water-used-count/export/excel',
		fileName: '用水记录统计.xls',
	},
	2: {
		url: '/monitor/report/water-used-count/export/excel',
		fileName: '用水记录统计.xls',
	},
	3: {
		url: '/monitor/report/water-used-count/export/excel',
		fileName: '用水记录统计.xls',
	},
}

const statisticMap = {
	deviceDevelop: apiGetStaticsDeviceDevelop,
	alarmDeal: apiGetStaticsAlarmProcess,
}
import pageMap from '../page-config/index'
import { apiGetWaterRegionTree } from '@/apis/regionManage.api'
import {
	exportReport,
	apiGetDeviceDevelopList,
	apiGetAlarmProcessList,
	apiGetDeviceAlarmList,
	apiGetSmsPushList,
	apiGetManufacturerList,
	apiGetEventModelList,
	apiReportMeterReading,
	apiReportNoUpload,
	apiReportValve,
	apiGetStaticsDeviceDevelop,
	apiGetStaticsAlarmProcess,
	apiGetUseWaterStatistic,
	apiGetUseWaterDetails,
} from '@/apis/statisticAnalysis.api'
import { apiGetDeviceTypeList } from '@/apis/account.api'
import { apiTenantIsolationOrg } from '@/apis/login.api'
import { apiGetTenantList } from '@/apis/tenant.api'
import { statisDimension } from '@/pages/statistic-analysis/page-config/const'
import { transDataList } from '@/utils/business'
import { isBlank } from '@/utils/validate'
import { mapGetters } from 'vuex'

export default {
	name: '',
	components: {},
	props: {
		type: String,
	},
	data() {
		return {
			tableData: [],
			params: {},
			searchOption: {},
			loading: false,
			total: 0,
			currentPage: 1,
			pageSize: 20,
			dynamicColumns: [],
			paramsBak: {},
			totalStatistic: null,
			useWaterRecordQueryType: 0,
			afterSearchParams: {},
			selectLoading: {},
		}
	},
	computed: {
		rednderConfig() {
			const config = pageMap[this.type]
			config.filterArr = config.filterArr.map(item => {
				return {
					...item,
					filterList: item.filterList.filter(
						el => isBlank(el.tenantType) || el.tenantType === this.tenantType,
					),
				}
			})
			if (typeof config.columns !== 'function') {
				config.columns = config.columns.filter(
					el => isBlank(el.tenantType) || el.tenantType === this.tenantType,
				)
			}
			return config
		},
		columns() {
			if (this.useWaterRecordQueryType !== 0 && this.type === 'useWaterRecord') {
				const dimensionItem = statisDimension.useWaterRecord.find(m => m.value === this.useWaterRecordQueryType)
				return [{ key: 'conditionColumn', name: dimensionItem.label }].concat(pageMap[this.type].columns1)
			}
			const { columns } = this.rednderConfig
			const isFunc = typeof columns === 'function'
			const fixedColumns = isFunc ? columns(this) : columns
			return [...this.dynamicColumns, ...fixedColumns]
		},
		headerData() {
			let { header } = this.rednderConfig
			return {
				pic: header.pic,
				title: header.title,
				desc: header.desc,
			}
		},
		paramsJSON() {
			return JSON.stringify(this.params)
		},
		remoteMethodMap() {
			return {
				queryTenantOptions: this.queryTenantOptions,
			}
		},
		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType || '0'
		},
		...mapGetters({
			dataList: 'dataList',
			userInfo: 'userInfo',
		}),
	},
	watch: {
		'rednderConfig.filterArr': {
			immediate: true,
			deep: true,
			handler(val) {
				val.forEach(item => {
					item.filterList.map(el => {
						this.getDicTionary(el.key)
						this.$set(this.params, el.key, !isBlank(el.default) ? el.default : null)
					})
				})
				this.paramsBak = { ...this.params }
			},
		},

		'params.deviceTypeClassify'() {
			this.params.deviceTypeIdList = null
			apiGetDeviceTypeList({ tenantId: this.tenantId, deviceTypeClassify: this.params.deviceTypeClassify }).then(
				res => {
					let list = res.records || []
					let val = list.map(item => {
						return {
							value: item.deviceTypeId,
							label: item.deviceTypeName,
						}
					})
					this.$set(this.searchOption, 'deviceTypeId', val)
				},
			)
		},
	},
	created() {
		this.initSearchFormdata()
		this.getTableData(1)
		this.getStatisticTotal()
	},
	mounted() {},
	methods: {
		handleSizeChange(size) {
			this.pageSize = size
			this.getTableData(1)
		},
		handleFilters(arr) {
			if (this.userInfo?.needPeekIsolation) return arr
			// 当前账户无子机构过滤掉机构查询条件
			const result = arr.filter(item => item.key !== 'orgCode')
			return result
		},
		initSearchFormdata() {
			if (
				['meterRate', 'valveOperate', 'deviceDevelop', 'alarmDeal', 'useWaterRecord', 'smsPush'].includes(
					this.type,
				)
			) {
				const startDate = this.dayjs()
					.subtract(['deviceDevelop', 'alarmDeal'].includes(this.type) ? 30 : 7, 'day')
					.format(this.type === 'smsPush' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')

				const endDate = this.dayjs().format(this.type === 'smsPush' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')
				this.$set(this.params, 'dateSection', [startDate, endDate])
			}
			if (this.type === 'useWaterRecord') {
				this.$set(this.params, 'queryType', 0)
			}
		},

		getSearchParams() {
			let obj = {
				tenantId: this.tenantId,
			}
			this.dynamicColumns = []
			for (var key in this.params) {
				let val = this.params[key]
				if (!isBlank(val)) {
					if (key === 'dateSection') {
						if (this.type === 'smsPush') {
							obj.startDate = this.dayjs(val[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
							obj.endDate = this.dayjs(val[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
						} else {
							obj.startDate = this.dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss')
							obj.endDate = this.dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss')
						}
					} else {
						obj[key] = val
					}
				}
				// 机构参数处理
				if (key === 'orgCode' && val) {
					obj[key] = [val]
				}

				// 统计维度参数+表格展示字段处理
				if (key === 'statisticsType' && obj[key]) {
					const tempArray = typeof obj[key] === 'string' ? [obj[key]] : [...obj[key]]

					const options = statisDimension[this.type]
					const dynamicColumns = []
					tempArray.map(item => {
						const columnItem = options.find(o => o.value === item)
						if (columnItem) {
							const { label, columnKey } = columnItem
							dynamicColumns.push({ key: columnKey, name: label, tooltip: true })
						}
					})
					this.dynamicColumns = dynamicColumns
					obj[key] = tempArray.join(',')
				}
			}
			this.afterSearchParams = { ...obj }
			return obj
		},
		getTableData(current) {
			this.loading = true
			let obj = this.getSearchParams(current)
			obj.current = current
			obj.size = this.pageSize
			const apiMap = {
				deviceDevelop: apiGetDeviceDevelopList,
				alarmDeal: apiGetAlarmProcessList,
				factoryAlarm: apiGetDeviceAlarmList,
				smsPush: apiGetSmsPushList,
				meterRate: apiReportMeterReading,
				manyDaysNoUpload: apiReportNoUpload,
				valveOperate: apiReportValve,
			}
			const useWaterApiMap = {
				0: apiGetUseWaterDetails,
				1: apiGetUseWaterStatistic,
				2: apiGetUseWaterStatistic,
				3: apiGetUseWaterStatistic,
			}
			const API = this.type === 'useWaterRecord' ? useWaterApiMap[obj.queryType] : apiMap[this.type]
			this.useWaterRecordQueryType = obj.queryType
			API({ ...obj, isolationOrgCode: obj.orgCode?.length ? obj.orgCode[0] : null })
				.then(res => {
					this.tableData = res.records || []
					this.total = res.total
					this.gasTotal = res.totalResult?.totalAmount
					this.currentPage = res.current
				})
				.catch(() => {
					this.tableData = []
					this.total = 0
					this.gasTotal = 0
				})
				.finally(() => {
					this.loading = false
				})
		},

		async getStatisticTotal() {
			if (this.tenantType == 1 && ['deviceDevelop', 'alarmDeal'].includes(this.type)) {
				const data = await statisticMap[this.type](this.getSearchParams())
				this.totalStatistic = data
			}
		},

		getDicTionary(key) {
			const { eventSource, eventName } = this.dataList
			let userTypeArr = JSON.parse(JSON.stringify(this.$store.getters.dataList.userType)) || []
			switch (key) {
				case 'deviceTypeClassify':
					this.$set(
						this.searchOption,
						'deviceTypeClassify',
						this.$store.getters.dataList.deviceTypeClassify.map(m => {
							return {
								label: m.name,
								value: m.defaultValue,
							}
						}),
					)
					return
				case 'secondCategory':
					this.$set(this.searchOption, 'secondCategory', [])
					return
				case 'manufacturerId':
					apiGetManufacturerList({
						current: 1,
						size: 9999,
						tenantId: this.$store.getters.userInfo.tenantId || undefined,
					}).then(res => {
						let list = res.records || []
						let val = list.map(item => {
							return {
								value: item.manufacturerId,
								label: item.manufacturerName,
							}
						})
						this.$set(this.searchOption, 'manufacturerId', val)
					})
					return
				case 'deviceTypeIdList':
					apiGetDeviceTypeList({ tenantId: this.tenantId }).then(res => {
						let list = res.records || []
						let val = list.map(item => {
							return {
								value: item.deviceTypeId,
								label: item.deviceTypeName,
							}
						})
						this.$set(this.searchOption, 'deviceTypeId', val)
					})
					return
				case 'alarmType':
					apiGetEventModelList().then(res => {
						let list = res.list || []
						let val = list.map(item => {
							return {
								value: item.id,
								label: item.alarmName,
							}
						})
						this.$set(this.searchOption, 'alarmType', val)
					})
					return
				case 'eventSource': // 操作来源下拉列表
					this.$set(this.searchOption, 'eventSource', transDataList(eventSource) || [])
					return
				case 'eventName': // 操作类型下拉列表
					this.$set(this.searchOption, 'eventName', transDataList(eventName) || [])
					return
				case 'waterRegionCode':
					this.queryWaterRegionCodeOptions()
					return
				case 'userTypeList':
					if (this.type === 'deviceDevelop' && this.tenantType === '1') {
						userTypeArr.push({
							defaultValue: '--',
							name: '待安装',
							sortCode: 'userType',
							sortName: '客户大类',
							sortNo: 99,
							tenantType: '1',
						})
					}
					this.$set(this.searchOption, 'userType', transDataList(userTypeArr))
					return
				case 'orgCode':
					if (this.userInfo?.needPeekIsolation) {
						this.queryOrgCodeOptions()
					}
					return
				case 'tenantId':
					this.queryTenantOptions()
					return
			}
		},

		async queryWaterRegionCodeOptions() {
			const data = await apiGetWaterRegionTree()
			this.$set(this.searchOption, 'waterRegionCode', data)
		},

		async queryOrgCodeOptions() {
			const data = await apiTenantIsolationOrg()
			this.$set(
				this.searchOption,
				'orgCode',
				(data || []).map(m => {
					return {
						label: m.name,
						value: m.orgCode,
					}
				}),
			)
		},

		async queryTenantOptions(name = '') {
			this.$set(this.selectLoading, 'tenantId', true)
			try {
				const { dataList = [] } = await apiGetTenantList({ name, page: 0, size: 9999 })
				this.$set(
					this.searchOption,
					'tenantId',
					dataList.map(item => {
						return {
							label: item.name,
							value: item.id,
						}
					}),
				)
			} finally {
				this.$set(this.selectLoading, 'tenantId', false)
			}
		},

		pageChange(val) {
			this.getTableData(val)
		},
		query() {
			this.$refs.reportForm.validate(valid => {
				if (valid) {
					this.getTableData(1)
				}
			})
			this.getStatisticTotal()
		},
		reset() {
			this.params = { ...this.paramsBak }
			this.initSearchFormdata()
			this.$refs.reportForm.clearValidate()

			this.getTableData(1)
			this.getStatisticTotal()
		},
		// 导出报表
		exportTable() {
			if (!this.tableData.length) {
				return this.$message.warning('暂无表格数据')
			}
			this.$toast('下载中，请稍后...')
			let obj = this.getSearchParams()
			const url =
				this.type === 'useWaterRecord' ? useWaterRecordExportMaps[obj.queryType].url : exportMaps[this.type].url
			const fileName =
				this.type === 'useWaterRecord'
					? useWaterRecordExportMaps[obj.queryType].fileName
					: exportMaps[this.type].fileName
			let myObj = {
				method: 'post',
				url,
				fileName,
				data: obj,
			}
			exportReport(myObj, 'excel', '', this.$toast)
		},
	},
}
</script>
<style lang="scss" scoped>
.common-shell {
	@include base-button(150px);
	height: 100%;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	&-content {
		flex: 1;
		display: flex;
		height: 0;
		.left-filter {
			width: 366px;
			height: 100%;
			padding: 18px 20px 12px;
			border-right: 1px solid #f1f1f1;
			box-sizing: border-box;
			overflow: auto;
			.filter-modules {
				padding-bottom: 10px;
				.title {
					font-size: 17px;
					font-weight: 600;
					color: #333333;
				}
				.item {
					margin: 20px 0;
				}
			}
			.button-zone {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}
		.right-table {
			flex: 1;
			width: 0;
			padding: 18px 20px 0;
			.table {
				height: 100%;
				display: flex;
				flex-direction: column;
				.water-statistic {
					margin-bottom: 12px;
					display: flex;
					.t {
						margin-right: 20px;
					}
					.statistic-item {
						margin-right: 24px;
						display: flex;
						align-items: center;
						p {
							color: #999;
							margin-right: 6px;
						}
					}
				}
				.table-content {
					flex: 1;
					height: 0;
				}
			}
		}
	}
}
::v-deep {
	.el-form-item--small .el-form-item__content {
		line-height: 0;
	}
	.gc-custom-search {
		width: initial !important;
	}
}
</style>
